/**
 * Debug utilities for development logging.
 * All logs are disabled in production builds.
 */

const isDev = import.meta.env.DEV;

/**
 * Development-only console.log wrapper.
 * Logs are completely stripped in production.
 */
export function devLog(tag: string, ...args: unknown[]): void {
  if (isDev) {
    console.log(`[${tag}]`, ...args);
  }
}

/**
 * Development-only console.warn wrapper.
 */
export function devWarn(tag: string, ...args: unknown[]): void {
  if (isDev) {
    console.warn(`[${tag}]`, ...args);
  }
}

/**
 * Development-only console.error wrapper.
 * Note: Critical errors should always be logged, use console.error directly for those.
 */
export function devError(tag: string, ...args: unknown[]): void {
  if (isDev) {
    console.error(`[${tag}]`, ...args);
  }
}

/**
 * Performance timing helper for development.
 * Returns a function to call when the operation completes.
 */
export function devTime(label: string): () => void {
  if (!isDev) return () => {};
  
  const start = performance.now();
  return () => {
    const duration = Math.round(performance.now() - start);
    console.log(`[PERF] ${label}: ${duration}ms`);
  };
}
